import React, { useState } from "react";
import { NFDateInput } from "../../../../Shared/NewForms/NFDateInput";
import { useTranslation } from "react-i18next";
import { Col, Row } from "react-bootstrap";
import { NFTextInput } from "../../../../Shared/NewForms/NFTextInput";
import { NFLookupCompany } from "../../../../Shared/NewForms/NFLookupCompany";
import { NFLookupCashflowItem } from "../../../../Shared/NewForms/NFLookupCashflowItem";
import { NFLookupBankAccount } from "../../../../Shared/NewForms/NFLookupBankAccount";
import { NFLookupInput } from "../../../../Shared/NewForms/NFLookupInput";
import { EnumHelper } from "../../../../../helpers/EnumHelper";
import { NFLookupDivision } from "../../../../Shared/NewForms/NFLookupDivision";
import { NFLookupPaymentRequests } from "../../../../Shared/NewForms/NFLookupPaymentRequests";
import { NFIntInput } from "../../../../Shared/NewForms/NFIntInput";
import { NFLookupCurrency } from "../../../../Shared/NewForms/NFlookupCurrency";
import ExpenseBankGeneralFunction from "./ExpenseBankGeneralFunction";
import { NFLookupEmployee } from "../../../../Shared/NewForms/NFLookupEmployee";
import { useFormContext } from "react-hook-form";
const ExpenseBanksDetailPayrolPaymentDetail = () => {
  const { t } = useTranslation();
  const {watch} = useFormContext();
  const [showModal, setShowModal] = useState(false);

  const handleListChange = (selectedOption: number) => {
    if (selectedOption === 0) {
      setShowModal(true);
    } else if (selectedOption === 1) {
      setShowModal(false);
    }
  };

  return (
    <Row>
      <Col sm={6}>
        <NFDateInput title={t("DocumentDate")} fieldName={"documentDate"} required />
        <NFTextInput title={t("Document#")} disabled fieldName={"documentNumber"} />
      </Col>
      <Col sm={6}>
        <NFDateInput title={t("ProcessedDate")} fieldName="processedDate" required />
        <NFLookupCompany fieldName="companyId" title={t("Company")} required />
      </Col>
      <Col sm={6}>
        <NFDateInput title={t("PaymentDate")} fieldName={"paymentDate"} required />
        <NFLookupCashflowItem fieldName="cashFlowItemId" title={t("CashFlowItem")} required />
      </Col>
      <Col>
        <NFLookupEmployee title={t("Employee")} fieldName="employeeId" required />
      </Col>
      <Col sm={6}>
        <NFLookupBankAccount fieldName="bankAccountId" title={t("BankAccount")} />
      </Col>
      <Col sm={6}>
        <NFTextInput fieldName="comment" title={t("Comment")} />
      </Col>
      <Col sm={6}>
        <NFLookupInput
          title={t("AsAListNoSplit")}
          fieldName={"amountOfPayments"}
          items={EnumHelper.GetOutgoingBankCashListSplitTypeEnum()}
          onValueChange={handleListChange}
          required={true}
        />
      </Col>
      <Col sm={6}>
        <NFLookupDivision fieldName="divisionId" title={t("Division")} companyId={watch('companyId')}/>
      </Col>
      <Col sm={6}>
        <NFLookupPaymentRequests fieldName="paymentRequestId" title={t("Payment")} />
      </Col>
      <Col sm={6}>
        <NFIntInput title={t("Amount")} fieldName={"amount"} required={true} />
      </Col>
      <Col sm={6}>
        <NFLookupCurrency title={t("Currency")} fieldName={"currencyId"} required={true} />
      </Col>
      {showModal && <ExpenseBankGeneralFunction />}
    </Row>
  );
};

export default ExpenseBanksDetailPayrolPaymentDetail;
